import { produce } from 'immer'
import {
  SET_AGENT_SHORTCUT,
  SET_IS_AGENT_OPEN,
  SetAgentShortcutAction,
  SetIsAgentOpenAction,
} from 'src/agent/redux/agent.actions'
import { PromptTemplate } from 'src/queries/agent/network/agent.models'

export type AgentPlacement = 'top' | 'bottom' | 'left' | 'right'

interface AgentShortcutBase {
  refId: string
  placement: AgentPlacement
}

interface AgentShortcutWithPrompt extends AgentShortcutBase {
  initialPrompt: string
}

interface AgentShortcutWithPromptTemplate extends AgentShortcutBase {
  initialPromptTemplate: PromptTemplate
}

export type AgentShortcut =
  | AgentShortcutWithPrompt
  | AgentShortcutWithPromptTemplate

export type AgentState = {
  isAgentOpen: boolean
  shortcut?: AgentShortcut
}

export const initialState: AgentState = {
  isAgentOpen: false,
}

export type Actions = SetIsAgentOpenAction | SetAgentShortcutAction

const AgentReducer = (state = initialState, action: Actions): AgentState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case SET_IS_AGENT_OPEN: {
        draft.isAgentOpen = action.payload.isAgentOpen
        if (!action.payload.isAgentOpen) {
          draft.shortcut = undefined
        }
        return draft
      }

      case SET_AGENT_SHORTCUT: {
        draft.shortcut = action.payload.shortcut
        return draft
      }
    }
  })
}

export default AgentReducer
